document.addEventListener('DOMContentLoaded', () => {

    const elements = document.querySelectorAll('.reveal');

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if(entry.isIntersecting){

                entry.target.classList.add('is-visible');

            }

        });

    },{

        threshold:.18

    });

    elements.forEach(element => observer.observe(element));

});